import { render, staticRenderFns } from "./TemplateLoaderPagesSingle.vue?vue&type=template&id=f5ac8b64&scoped=true&"
import script from "./TemplateLoaderPagesSingle.vue?vue&type=script&lang=js&"
export * from "./TemplateLoaderPagesSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ac8b64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VFadeTransition})
